import React, { useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";

import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import LoginImage from "../../assets/images/on-removebg-preview.svg";
import Navbar from "../../components/Navbar";
import withRouter from "../../components/common/withRouter";
import Footer from "../../components/footerAccessibilityPageFooter";
import { createUsers } from "../../slice/auth/login/thunk";
import { useDispatch } from "react-redux";

const UserType = (props) => {
  document.title = "Authentication";

  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const email = location.state && location.state.email;
  const mobileNumber = location.state && location.state.mobileNumber;
  const isFromSocial = params.isFromSocial;
  const isFromSocialEmail = params.email;
  const firebaseToken = localStorage.getItem("firebaseToken");
  console.log("isFromSocial", isFromSocial);
  const [userData, setUserData] = useState();
  const [error, setError] = useState("");

  const getStateObject = (userType) => {
    return email
      ? { userType: userType, email }
      : mobileNumber
      ? { userType: userType, mobileNumber }
      : null;
  };

  const handleSelection = async (userType) => {
    if (isFromSocial) {
      console.log(`Dispatching API for ${userType}`);
      try {
        const payload = {
          email: isFromSocialEmail,
          userType: userType,
          isFromSocial: true,
          idToken: firebaseToken,
        };
        console.log("payload", payload);
        const usersData = await dispatch(
          createUsers(payload, props.router.navigate)
        );
        //setUserData(usersData.data);
        let path = "";
        if (userType == "JobSeeker") {
          path = "/home";
        } else if (userType == "Employer") {
          console.log("inside te employer part");
          path = "/employers/jobpostdashbord";
        } else {
          console.log("inside te else part");
          path = "/";
        }
        console.log("path", path);
        navigate(path);
        // Swal.fire('created!', 'login with your email or mobileNumber', 'success');
      } catch (error) {
        console.log("error", error);
        setError(error.message || "An error occurred");
      }
    } else {
      // Navigate to the account creation page with state
      navigate("/auth/createAccount", { state: getStateObject(userType) });
    }
  };

  return (
    <Container fluid className="p-0 signup-bg d-flex flex-column min-vh-100">
      <Navbar />
      <div class="flex-grow-1 d-flex justify-content-center align-items-center container p-0">
        <Row className="w-100 d-flex justify-content-between align-items-center m-0">
          <Col md={5}>
            <Card className="signup-card text-dark">
              <h5>Ready for the next step?</h5>
              <p> Create an account for tools to help you</p>
              <br />
              {/* <Button className="btn-color-primary py-3">
                                    <strong>
                                        <Link to="/auth/createAccount" className="text-white text-decoration-none fs-5" state={getStateObject('JobSeeker')}> Jobseeker </Link>
                                    </strong>
                                </Button>
                                <Button className="btn-color-primary py-3 mt-3">
                                    <strong>
                                        <Link to="/auth/createAccount" className="text-white text-decoration-none fs-5" state={getStateObject('Employer')}> Employer</Link>
                                    </strong>
                                </Button> */}
              <Button
                className="btn-color-primary py-3"
                onClick={() => handleSelection("JobSeeker")}
              >
                <strong className="text-white text-decoration-none fs-5">
                  Jobseeker
                </strong>
              </Button>
              <Button
                className="btn-color-primary py-3 mt-3"
                onClick={() => handleSelection("Employer")}
              >
                <strong className="text-white text-decoration-none fs-5">
                  Employer
                </strong>
              </Button>
            </Card>
          </Col>

          <Col md={5} className="d-none d-md-block">
            <Image className="login-img" src={LoginImage} fluid />
          </Col>
        </Row>
      </div>
      <Footer className="mt-auto" />
    </Container>
  );
};
export default withRouter(UserType);
